import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { DataField } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import EditDataField from '@/components/data-fields/EditDataField.vue';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        dataField: DataField;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataFieldTableActions',
  props: {
    dataField: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.dataField }, {
    default: _withCtx(() => [
      _createVNode(EditDataField, { "data-field": _ctx.dataField }, null, 8, ["data-field"]),
      (_unref(hasPermission)(_unref(Permission).SYSTEM_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 0,
            route: _ctx.route('v2.data-fields.destroy', _ctx.dataField.data_field_id),
            "query-key": [_unref(QueryKey).DATA_FIELDS]
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})